<script setup lang="ts">
import RatingStar from '~/components/product/review/RatingStar.vue'

const props = defineProps<{
  rating: number
  size?: 'small' | 'medium' | 'large'
}>()

const starsPercentagesFilled = computed((): number[] => {
  if (!props.rating) {
    return []
  }

  // Split the number into integer and fractional parts
  const integerPart = Math.floor(props.rating)
  const fractionalPart = props.rating % 1

  // Add percentages of integer and fractional part into array
  const percentages = Array.from({ length: integerPart }, () => 100)
  if (fractionalPart > 0) {
    percentages.push(Math.round(fractionalPart * 100))
  }

  return percentages
})
</script>

<template>
  <div class="rating-stars">
    <RatingStar
      v-for="(_rating, index) in 5"
      :key="`rating-star-${index}`"
      :percentage-filled="starsPercentagesFilled[index] || 0"
      :size="size"
    />
  </div>
</template>

<style lang="scss" scoped>
.rating-stars {
  display: flex;
}
</style>
